import React from 'react';
import PropTypes from 'prop-types';
import { renderComponent, branch } from 'recompose';
import ReactSimpleCurrency from 'react-simple-currency';

const CustomAmount = ({ onCustomGcChange, customGcAmount, onCustomGcSubmit }) => (
  <form
    className="u-text-center layout layout--flush layout__item u-1/1 u-pl-"
    onSubmit={onCustomGcSubmit}
  >
    <div className="layout__item u-3/4">
      <ReactSimpleCurrency
        className="c-input"
        min="0"
        placeholder="Gift Card Amount"
        required
        value={customGcAmount}
        onInputChange={onCustomGcChange}
        unit="$"
      />
    </div>
    <div className="layout__item u-1/4">
      <button className="c-btn c-btn--default u-width-full" disabled={customGcAmount <= 0}>
        Set
      </button>
    </div>
  </form>
);

CustomAmount.propTypes = {
  onCustomGcChange: PropTypes.func.isRequired,
  customGcAmount: PropTypes.number.isRequired,
  onCustomGcSubmit: PropTypes.func.isRequired,
};

const OpenCustomAmount = ({ toggleCustomGc, hasCustomGcAmount }) => (
  <div className="u-text-center layout layout--flush layout__item u-1/1 u-pl-">
    <button className="c-btn c-btn--default layout__item u-1/1" onClick={toggleCustomGc}>
      { hasCustomGcAmount ? 'Change Amount' : 'Custom Amount' }
    </button>
  </div>
);

OpenCustomAmount.propTypes = {
  toggleCustomGc: PropTypes.func.isRequired,
  hasCustomGcAmount: PropTypes.bool.isRequired,
};

export default branch(
  props => !props.customGcOpen,
  renderComponent(OpenCustomAmount),
)(CustomAmount);



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/GiftCardAmount/CustomAmount.jsx